import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable max-len */
import { OV_EMS_CDN } from '../../config/theme';
var BASE_IMAGE_URL = "".concat(OV_EMS_CDN, "media/pages/exercise-dress/");
var MAIN_PDP_URL = '/products/exercise-dress-shorts';
var heroImage = "".concat(BASE_IMAGE_URL, "hero-1.jpg");
var heroImageMobile = "".concat(BASE_IMAGE_URL, "hero-1-mobile.jpg");
var messages = [{
  alt: 'Woman standing on a cliff wearing the Exercise Dress in Black',
  id: 'first',
  image: "".concat(BASE_IMAGE_URL, "slide-1.jpg"),
  imageStyle: {
    left: 0,
    top: '50%',
    transform: 'translate3d(0, -25%, 0)'
  },
  message: 'Climb It',
  mobileClass: 'bottom'
}, {
  alt: 'Woman snowboards down a sand dune wearing the Exercise Dress in Black',
  id: 'second',
  image: "".concat(BASE_IMAGE_URL, "slide-2.jpg"),
  imageStyle: {
    right: 0,
    top: '72px'
  },
  message: 'Send It',
  mobileClass: 'top'
}, {
  alt: 'Group of women running a marathon wearing the Exercise Dress in various colors',
  id: 'third',
  image: "".concat(BASE_IMAGE_URL, "slide-3.jpg"),
  message: 'Run It',
  imageStyle: {
    left: '12%',
    top: '50%',
    transform: 'translate3d(20px, -25%, 0)'
  },
  mobileClass: 'center'
}, {
  id: 'fourth',
  image: '',
  message: 'Do Anything'
}];
var shopPoster = {
  cta: 'Shop The Exercise Dress',
  image: "".concat(BASE_IMAGE_URL, "footer-1.jpg"),
  imageMobile: "".concat(BASE_IMAGE_URL, "footer-1-mobile.jpg"),
  message: 'See for yourself.',
  url: MAIN_PDP_URL
};
var featureBlock = {
  color: 'White',
  copy: 'The Exercise dress is designed with functional features that allow you to move freely.',
  id: '0',
  image: "".concat(BASE_IMAGE_URL, "content-1.jpg"),
  price: 100,
  title: 'The Exercise Dress',
  url: MAIN_PDP_URL
};
var props = {
  featureBlocks: [_objectSpread(_objectSpread({}, featureBlock), {}, {
    id: 'first',
    imageRight: true,
    url: "".concat(MAIN_PDP_URL, "?variant=39439377301582")
  }), _objectSpread(_objectSpread({}, featureBlock), {}, {
    color: 'Black',
    id: 'second',
    image: "".concat(BASE_IMAGE_URL, "content-2.jpg"),
    imageRight: false,
    copy: 'A built-in shorts liner has two pockets for phones — or snacks — and keeps you covered in even the most compromising positions.',
    url: "".concat(MAIN_PDP_URL, "?variant=39439379103822")
  }), _objectSpread(_objectSpread({}, featureBlock), {}, {
    color: 'Navy',
    id: 'third',
    image: "".concat(BASE_IMAGE_URL, "content-3.jpg"),
    imageRight: true,
    copy: 'Say goodbye to bunching. Our internal grippers are there to keep your shorts in place.',
    url: "".concat(MAIN_PDP_URL, "?variant=39439379464270")
  })],
  heroImage: heroImage,
  heroImageMobile: heroImageMobile,
  heroTitle: 'The Exercise Dress.',
  heroSubtitle: 'The dress that started it all.',
  messageBot: 'in a Dress',
  messages: messages,
  messageTop: 'You Can',
  price: 100,
  rating: 4.7,
  shopPoster: shopPoster,
  title: 'The Exercise Dress',
  url: MAIN_PDP_URL
};
export default props;